import React from "react";
import { I18n } from "@aws-amplify/core";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";

import CloseIcon from "../../Common/CloseIcon";
import CustomButton from "../../Common/CustomButton";

import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const DataPolicy = (props) => {
  const { close, classes, photos, savePhotos, saveAndEnroll } = props;
  const [notify, setNotify] = React.useState(true);

  return (
    <Grid
      container
      direction="column"
      alignItems="stretch"
      style={{ height: "100%", width: "400px" }}
      wrap="nowrap"
    >
      <Grid item>
        <Grid container direction="row-reverse">
          <Grid item xs={2} className={classes.closeBtn}>
            <CloseIcon closeFunction={close} />
          </Grid>
          <Grid item xs={8} />
        </Grid>
      </Grid>
      <Grid item xs style={{ padding: "0px 24px 24px" }}>
        <Grid container direction="column" alignItems="center">
          <Grid
            item
            className="text-54 text-center bold-500"
            style={{ textTransform: "uppercase" }}
          >
            {I18n.get("profiles_dataPolicy")}
          </Grid>
          <Grid item style={{ margin: "24px 0px 38px 0px" }}>
            <Grid container wrap="nowrap">
              <Grid item>
                <Checkbox
                  color="primary"
                  checked={notify}
                  onChange={() => setNotify(!notify)}
                />
              </Grid>
              <Grid item className="text-87 bold-500">
                {I18n.get("profiles_dataPolicyNotify")}
              </Grid>
            </Grid>
          </Grid>
          {!notify && (
            <>
              <Grid item style={{ paddingBottom: "15px" }}>
                <img src={images.warningIcon} alt="warning" />
              </Grid>
              <Grid
                item
                className="text-54"
                style={{
                  padding: "10px",
                  border: "2px solid " + colors.warningOrange,
                  borderRadius: "2px",
                  marginBottom: "24px",
                  textAlign: "justify",
                }}
              >
                {I18n.get("profiles_dataPolicyLongMsg")}
              </Grid>
            </>
          )}
          <Grid item className={classes.postCreationBtn}>
            <CustomButton
              variant="contained"
              color="primary"
              onClick={saveAndEnroll}
              style={{ marginBottom: "12px" }}
            >
              {I18n.get("profiles_proceedWithEnrollment")}
            </CustomButton>
          </Grid>
          {!notify && (
            <Grid item className={classes.postCreationBtn}>
              <CustomButton
                color="primary"
                onClick={savePhotos}
                disabled={photos.length === 0}
              >
                {I18n.get("profiles_saveWithoutEnrolling")}
              </CustomButton>
            </Grid>
          )}
          <Grid item className={classes.postCreationBtn}>
            <CustomButton color="primary" onClick={close}>
              {I18n.get("site_close")}
            </CustomButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

DataPolicy.propTypes = {
  close: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  photos: PropTypes.array.isRequired,
  savePhotos: PropTypes.func.isRequired,
  saveAndEnroll: PropTypes.func.isRequired,
};

export default DataPolicy;
